import { withAuth0 } from "@auth0/auth0-react";
import { Component } from "react";
import { connect } from "react-redux";
import {
  addToUserFavourite,
  deleteUserFavourite,
} from "../../../../redux/actions/favouritesActions";
import { showModal } from "../../../../redux/actions/modalActions";
import { Icon } from "../../../icons/Icon";
import LoginPrompt from "../../../popups/StandardPopup";
import UnlockPremiumModal from "../../../popups/UnlockPremiumModal";

interface Props {
  item_id: number;
  itemData?: ItemData; // Add itemData prop to pass the full item data
  auth0: any;
  user: UserState;
  deleteUserFavourite: any;
  addToUserFavourite: any;
  showModal: any;
  favourites: FavouritesState;
}

interface State {
  isFavourite: boolean;
}

class FavouriteIndicator extends Component<Props, State> {
  state = {
    isFavourite: false,
  };

  componentDidMount = () => {
    // check if is user fav
    this.setState({ isFavourite: this.isItemUsersFav(this.props.item_id) });
  };

  componentDidUpdate = (prevProps: Props) => {
    // Update favorite state when favorites list changes
    if (this.props.favourites.favourites !== prevProps.favourites.favourites) {
      const newIsFavorite = this.isItemUsersFav(this.props.item_id);
      // console.log(`Updating favorite state for item ${this.props.item_id} from ${this.state.isFavourite} to ${newIsFavorite}`);
      this.setState({ isFavourite: newIsFavorite });
    }

    // Also update if item_id changes
    if (this.props.item_id !== prevProps.item_id) {
      const newIsFavorite = this.isItemUsersFav(this.props.item_id);
      // console.log(`Item ID changed from ${prevProps.item_id} to ${this.props.item_id}, updating favorite state to ${newIsFavorite}`);
      this.setState({ isFavourite: newIsFavorite });
    }
  };

  isItemUsersFav = (item_id: number) => {
    let isFavourite = false;
    if (this.props.favourites.favourites) {
      this.props.favourites.favourites.forEach((fav: Favourites) => {
        // Convert both to strings for comparison to handle type mismatches
        // The backend is returning the ID as a string while the frontend is using a number
        const itemIdStr = String(item_id);
        const favItemIdStr = String(fav.item.id);
        const favCrawlerIdStr = fav.item.crawler_id ? String(fav.item.crawler_id) : '';
        
        // Check if any of the IDs match
        if (favItemIdStr === itemIdStr || 
            // Check if the item has a property called shopify_id (added by backend)
            (fav.item as any).shopify_id === itemIdStr || 
            favCrawlerIdStr === itemIdStr) {
          isFavourite = true;
          // console.log(`Item ${item_id} is a favorite! Matched with:`, fav.item);
        }
      });
    }

    // console.log(`Checking if item ${item_id} is a favorite:`, isFavourite, this.props.favourites.favourites);
    return isFavourite;
  };

  clickedFavouriteIndicator = async () => {
    // if logged in
    if (this.props.auth0.isAuthenticated) {
      if (this.props.user.isPremium) {
        try {
          if (!this.state.isFavourite) {
            // Set isFavourite to true immediately for better UX
            this.setState({ isFavourite: true });
            // console.log(`Adding item ${this.props.item_id} to favorites...`);
            
            // Pass the full itemData if available
            await this.props.addToUserFavourite(
              this.props.item_id,
              this.props.itemData // Pass the full item data with pricing information
            );
            
            // console.log(`Item ${this.props.item_id} added to favorites successfully`);
          } else {
            // Set isFavourite to false immediately for better UX
            this.setState({ isFavourite: false });
            // console.log(`Removing item ${this.props.item_id} from favorites...`);
            
            // delete the fav
            await this.props.deleteUserFavourite(this.props.item_id);
            
            // console.log(`Item ${this.props.item_id} removed from favorites successfully`);
          }
        } catch (error) {
          console.error('Error updating favorites:', error);
          // Revert the state if the API call fails
          this.setState({ isFavourite: !this.state.isFavourite });
        }
      } else {
        this.showPopup("subscribe");
      }
    } else {
      // show the popup modal
      this.showPopup("subscribe");
    }
  };

  showPopup = (type: "login" | "subscribe") => {
    let modalContent;
    if (type === "subscribe") {
      modalContent = () => <UnlockPremiumModal />;
    } else {
      modalContent = () => <LoginPrompt type={"favourites"} />;
    }
    this.props.showModal({ component: modalContent });
  };

  render() {
    // Define the heart fill color based on favorite state
    const heartFillColor = this.state.isFavourite ? "#9c27b0" : "#eeeeee"; // Using a purple color for favorites
    
    return (
      <button
        style={{
          width: "40px",
          height: "40px",
          paddingRight: "10px",
          borderRadius: "0 8px 0 80% ",
          textAlign: "right",
          background: "transparent", // Keep background transparent
        }}
        onClick={() => this.clickedFavouriteIndicator()}
      >
        <Icon
          id="heart"
          size="s"
          fill={heartFillColor}
        />
      </button>
    );
  }
}
const mapStateToProps = (state: ReduxState) => ({
  user: state.user,
  favourites: state.favourites,
});
export default withAuth0<any>(
  connect(mapStateToProps, {
    deleteUserFavourite,
    addToUserFavourite,
    showModal,
  })(FavouriteIndicator)
);
